import { useState, useEffect, useRef, createContext } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import {
  CustomContainer,
  connect,
  useRouter,
  Cookie,
} from "../../components/atoms/DependencyHelper";
import microService from "../../utils/microServices";
import CheckoutPage from "../../components/organisms/checkoutPage/CheckoutPage";
import ButtonWithIcon from "../../components/atoms/buttons/buttonWithIcon/ButtonWithIcon";
import CheckoutAuthentication from "../../components/organisms/checkoutAuthentication/CheckoutAuthentication";
import CheckoutXds from "../../components/organisms/checkoutXds/CheckoutXds";
import CheckoutCreditCheck from "../../components/organisms/checkoutCreditCheck/CheckoutCreditCheck";
import CheckoutDelivery from "../../components/organisms/checkoutDelivery/CheckoutDelivery";
import CheckoutReview from "../../components/organisms/checkoutReview/CheckoutReview";
import CheckoutPayment from "../../components/organisms/checkoutPayment/CheckoutPayment";
import CheckoutOrderSummary from "../../components/molecules/checkoutOrderSummary/CheckoutOrderSummary";
import CheckoutOrderConfirmation from "../../components/organisms/checkoutOrderConfirmation/CheckoutOrderConfirmation";
import CheckoutPaymentError from "../../components/organisms/checkoutPaymentError/CheckoutPaymentError";
import PageHeading from "../../components/atoms/pageHeading/PageHeading";
import PageDescription from "../../components/atoms/pageDescription/PageDescription";
import FormRightSidebar from "../../components/atoms/formRightSidebar/FormRightSidebar";
import LoginModal from "../../components/atoms/loginModal/LoginModal";
import SyncError from "../../components/molecules/syncError/SyncError";
import PaymentRedirect from "../../components/organisms/paymentRedirect/PaymentRedirect";
import CheckoutPageError from "../../components/atoms/checkoutPageError/CheckoutPageError";
import styles from "../../components/organisms/checkoutPage/CheckoutPage.module.scss";
import labels from "../../config/labels";
import { maskMsisdn } from "../../services/upgradeService";
import ajaxService from "../../utils/ajaxServices";
import {
  getSAStatesService,
  getAddressTypesService,
  getLeadBucket,
} from "../../services/checkoutService";
import {
  africaCountryCode,
  appendCountryCode,
  getCookieValue,
  showSpinner,
  hideSpinner,
  imagePrefix,
  urlPrefix,
  isArrayNotEmpty,
  getCustomizableOptions,
  getClearCartQuery,
  formatNumbersWithComma,
  getCartGrandTotal,
  splitCartItems,
  checkIsOutOfStock,
  getSelectedVariant,
  setCookieConsentWrapper,
  getSessionStorage,
} from "../../utils/helperServices";
import * as Analytics from "../../services/analyticsUtag";
import * as pageAPI from "../../services/pageService";
import Seo from "../../components/atoms/Seo/Seo";
import config from "../../config/index";
import { CHECKOUT_CONFIG } from "../../config/constants";
import {
  addGuestCartProducts,
  addBundleProductToGuestCart,
  addCouponToCart,
  addSimpleProductToGuestCart,
  addConfigurableToGuestCart,
  setCartMulti,
  showGuestCart,
} from "../../Redux/actions/cartAction";
import {
  setPostCheckoutCurrentStep,
  removeCreditCheckStates,
  setPaymentMethodUrl,
  setPostOrderResponse,
} from "../../Redux/actions/checkoutAction";
import {
  journeyType,
  CheckoutJourneyContext,
} from "../../context/checkout-journey-context";
import CheckoutMahAuthentication from "../../components/organisms/checkoutMahAuthentication/CheckoutMahAuthentication";
import NotificationBox from "../../components/molecules/NotificationBox/NotificationBox";
import NumberTransfer from "../../components/organisms/NumberTransfer/NumberTransfer";
import { setHelpLeadBucket } from "../../Redux/actions/getHelpAction";

const k8sConfig = typeof window === "undefined" ? require("config") : "";

export const FlagsContext = createContext({
  vodacomPrepaidTransfer: false,
  otherPrepaidTransfer: false,
});

const PostCheckout = ({
  cartDetails,
  checkoutDetails,
  setPostCheckoutCurrentStep,
  removeCreditCheckStates,
  userLoggedIn,
  profileData,
  authDetails,
  paymentConfiguration,
  cartProductItems,
  personalDetailsData,
  contactDetailsData,
  dealCategoryId,
  addGuestCartProducts,
  addBundleProductToGuestCart,
  authDetailsData,
  vodacomPrepaidTransfer,
  otherPrepaidTransfer,
  numberTransferEnabled,
  addCouponToCart,
  addSimpleProductToGuestCart,
  addConfigurableToGuestCart,
  setCartMulti,
  showGuestCart,
  creditVettingDetails,
  setHelpLeadBucket,
  setPaymentMethodUrl,
  setPostOrderResponse,
  paymentOptionsEnabled,
  clickAndCollectEnabled,
}) => {
  const postCheckoutPageRef = useRef();

  const orderId = getCookieValue(config.order_id);
  const env = config.env;
  const cartIdCookie = getCookieValue("cart_id");
  const profileSyncFail = getCookieValue("profileSyncFail");

  const [metadata, setMetaData] = useState({});
  const [cartId, setCartId] = useState(cartIdCookie);
  const [redirectURL, setRedirectURL] = useState("");
  const [features, setFeatures] = useState({});
  const cartItems =
    cartDetails && cartDetails?.cartProductItems
      ? cartDetails.cartProductItems
      : [];
  const allPrices =
    cartDetails && cartDetails?.prices ? cartDetails.prices : null;
  const { dealCartProducts, onceOffCartProducts } =
    splitCartItems(cartProductItems);

  const onceOffSubTotal =
    allPrices && allPrices?.subtotal_including_tax?.value
      ? `R${formatNumbersWithComma(
          Math.round(allPrices.subtotal_including_tax.value * 100) / 100
        )}`
      : `R${formatNumbersWithComma(0)}`;

  const dealID = dealCartProducts[0]?.product?.sku;
  const primaryProductSku = dealCartProducts[0]?.product?.primary_product_sku;
  let contractType;
  if (
    dealCartProducts[0]?.customizable_options[0]?.values[0]?.label ===
    labels.deal_details.lbl_new_contract_deal_option
  ) {
    contractType = labels.deal_details.lbl_new_contract_deal;
  } else if (
    dealCartProducts[0]?.customizable_options[0]?.values[0]?.label ===
    labels.deal_details.lbl_upgrade_deal_option
  ) {
    contractType = labels.deal_details.lbl_upgrade_deal_option;
  }

  let monthlyCartProducts = [];
  for (const item of dealCartProducts) {
    for (let index = 0; index < item.quantity; index++) {
      monthlyCartProducts.push(item);
    }
  }

  let dealSku, monthlyCartVasProducts;
  if (Array.isArray(monthlyCartProducts)) {
    monthlyCartProducts.forEach((item) => {
      dealSku = item?.product?.sku;
      monthlyCartVasProducts = cartProductItems.filter(
        (cartProduct) =>
          cartProduct?.monthly_recurring &&
          cartProduct?.parent_product_sku == dealSku
      );
    });
  } else {
    dealSku = monthlyCartProducts?.product?.sku;
    monthlyCartVasProducts = cartProductItems.filter(
      (cartProduct) =>
        cartProduct?.monthly_recurring &&
        cartProduct?.parent_product_sku == dealSku
    );
  }
  if (Array.isArray(monthlyCartVasProducts)) {
    for (const item of monthlyCartVasProducts) {
      for (let index = 0; index < item.quantity; index++) {
        monthlyCartProducts.push(item);
      }
    }
  }

  const shippingAddress = cartDetails.shipping_address
    ? Array.isArray(cartDetails.shipping_address) &&
      cartDetails.shipping_address.length > 0
      ? cartDetails.shipping_address[0]
      : cartDetails.shipping_address
    : null;

  const billingAddress = cartDetails.billing_address
    ? Array.isArray(cartDetails.billing_address) &&
      cartDetails.billing_address.length > 0
      ? cartDetails.billing_address[0]
      : cartDetails.billing_address
    : null;

  const shippingMessageText =
    cartDetails && cartDetails.shippingMessageText
      ? cartDetails.shippingMessageText
      : null;

  const shippingFeeCalculateAmount =
    cartDetails &&
    cartDetails.shippingFeeCalculate &&
    cartDetails.shippingFeeCalculate.grand_total_amount
      ? cartDetails.shippingFeeCalculate.grand_total_amount
      : null;

  let carrierCode = cartDetails?.shippingFeeCalculate?.carrier_code;
  let methodCode = cartDetails?.shippingFeeCalculate?.method_code;

  const [journey, setJourney] = useState(
    checkoutDetails.authDetails?.information?.customerType == "EXISTING"
      ? contractType == labels.deal_details.lbl_upgrade_deal_option
        ? journeyType.upgrade
        : journeyType.addLine
      : contractType == labels.deal_details.lbl_upgrade_deal_option
      ? journeyType.upgrade
      : journeyType.newLine
  );
  const journeyProviderValue = { journey, setJourney };

  const [addressTypes, setAddressTypes] = useState([]);
  const [countryCode, setCountryCode] = useState("");
  const [countryName, setCountryName] = useState("");
  const [regions, setRegions] = useState([]);

  const [formContent, setFormContent] = useState(null);
  const [sidebarContent, setSidebarContent] = useState(null);
  const [faq, setFaq] = useState(null);
  const [notificationContent, setNotificationContent] = useState(null);

  const [allowPlaceOrder, setAllowPlaceOrder] = useState(true);
  const [continueDisabled, setContinueDisabled] = useState(true);
  const [showLoginModal, setShowLoginModal] = useState(true);

  const [activeStep, setActiveStep] = useState(null);
  const [activeStepNo, setActiveStepNo] = useState(0);
  const [customerStatus, setCustomerStatus] = useState(null);
  const [showOnceOff, setShowOnceOff] = useState(true);

  const clickAndCollectDelivery =
    dealCartProducts &&
    dealCartProducts[0]?.product?.enable_click_and_collect &&
    clickAndCollectEnabled &&
    !cartDetails?.isMulti
      ? true
      : false;

  const activeStepRef = useRef(activeStep);
  const router = useRouter();
  const paymentStatus = router.query;
  const previewMode = router.query?.previewMode === "on";

  const [showSnackBar, setShowSnackBar] = useState({
    visible: false,
    message: "",
    type: "default",
    className: "",
    dismissClass: "",
    textClass: "",
  });

  const [pageErr, setPageErr] = useState({
    type: "success",
    title: "We’ll be in contact soon!",
    desc: null,
    primaryLabel: null,
    primaryUrl: null,
    secondaryLabel: null,
    secondaryUrl: null,
    handlePrimaryClick: () => {},
    handleSecondaryClick: () => {},
    imgUrl: null,
    pageName: null,
    pageErrorType: null,
    additionalUtagData: null,
    dividerLine: false,
    subTitle: null,
    subDesc: null,
    ctaTitle: null,
    disablePrimary: false,
    preferences: [],
    defaultPreference: null,
    analyticsPageErrorCode: null,
    analyticsPageErrorMessage: null,
  });

  const [state, setState] = useState({
    heading: {
      title: "",
      desc: "",
      titleClass: "",
      descClass: "",
      id: "",
      class: "",
    },
    button: {
      secure: false,
      payment: false,
      lable: "Continue",
      backLable: "Back to cart",
      backButtonId: "back-cart",
      backButtonClass: "d-none",
      btnType: "submit",
      disable: false,
    },
    orderSummery: {
      variant: "plain",
    },
    steps: {
      all:
        journey == journeyType.upgrade
          ? cartDetails?.isMulti && paymentOptionsEnabled
            ? CHECKOUT_CONFIG.upgradeStepsTrackerWithPayment
            : CHECKOUT_CONFIG.upgradeStepsTracker
          : numberTransferEnabled &&
            cartDetails?.isMulti &&
            paymentOptionsEnabled
          ? CHECKOUT_CONFIG.newLineStepsTrackerWithNumberTransferPayment
          : numberTransferEnabled
          ? CHECKOUT_CONFIG.newLineStepsTrackerWithNumberTransfer
          : cartDetails?.isMulti && paymentOptionsEnabled
          ? CHECKOUT_CONFIG.newLineStepsTrackerWithPayment
          : CHECKOUT_CONFIG.newLineStepsTracker,
      show: false,
      width:
        journey == journeyType.upgrade
          ? "step-width-65"
          : numberTransferEnabled ||
            (cartDetails?.isMulti && paymentOptionsEnabled)
          ? "step-width-75"
          : "step-width-65",
    },
  });

  const { heading, button, orderSummery, steps } = state;

  async function featuresCheck() {
    try {
      let featuresResult = await ajaxService.httpGet( // TODO: Replace with redux features.
        "featureBaseUrl",
        "",
        "api",
        "features"
      );
      setFeatures(featuresResult);
      if (featuresResult?.multiCartEnabled && cartDetails?.isMulti) {
        setCartMulti(true);
      } else {
        setCartMulti(false);
      }
    } catch (e) {
      console.log("error", e);
    }
  }

  useEffect(() => {
    if (typeof window !== undefined) {
      setRedirectURL(window.location.href);
    }
    featuresCheck();
  }, []);

  useEffect(() => {
    if (
      isArrayNotEmpty(cartDetails.guestCartItems) &&
      cartDetails.totalQuantity > cartDetails.guestCartQty &&
      userLoggedIn &&
      customerStatus
    ) {
      fetchErrorDetails();
    }
  }, [cartDetails.totalQuantity, userLoggedIn, customerStatus]);

  useEffect(() => {
    if (userLoggedIn) {
      //Set the customer status(nc,ec,upgrade) value as per journey
      getCustomerStatus(journey);
      fetchAddressStateTypes();
      fetchFaqData();

      if (checkoutDetails.postCheckoutCurrentStep) {
        setLabels(checkoutDetails.postCheckoutCurrentStep);
        setActiveStep(checkoutDetails.postCheckoutCurrentStep);

        if (
          checkoutDetails.postCheckoutCurrentStep !== "login" &&
          checkoutDetails.postCheckoutCurrentStep !== "authentication"
        ) {
          history.pushState(
            { name: checkoutDetails.postCheckoutCurrentStep },
            null,
            window.location.pathname
          );
        }
      } else {
        setLabels("authentication");
        setActiveStep("authentication");
      }
    } else {
      setLabels("login");
      setActiveStep("login");
    }
  }, [userLoggedIn]);

  useEffect(() => {
    if (activeStep) {
      window.scrollTo(0, 0);
      let activeStepObjNo;
      let newActiveStep =
        cartDetails?.isMulti &&
        paymentOptionsEnabled &&
        (activeStep == "paymentRedirect" || activeStep == "paymentError")
          ? "payment"
          : activeStep == "paymentRedirect" || activeStep == "paymentError"
          ? "review"
          : activeStep;

      if (journey == journeyType.upgrade) {
        activeStepObjNo =
          cartDetails?.isMulti && paymentOptionsEnabled
            ? CHECKOUT_CONFIG.upgradeJourneyWithPayment[newActiveStep]
                ?.activeStepNo
            : CHECKOUT_CONFIG.upgradeJourney[newActiveStep]?.activeStepNo;
      } else {
        activeStepObjNo =
          numberTransferEnabled && cartDetails?.isMulti && paymentOptionsEnabled
            ? CHECKOUT_CONFIG.newLineJourneyWithNumberTransferPayment[
                newActiveStep
              ]?.activeStepNo
            : numberTransferEnabled
            ? CHECKOUT_CONFIG.newLineJourneyWithNumberTransfer[newActiveStep]
                ?.activeStepNo
            : cartDetails?.isMulti && paymentOptionsEnabled
            ? CHECKOUT_CONFIG.newLineJourneyWithPayment[newActiveStep]
                ?.activeStepNo
            : CHECKOUT_CONFIG.newLineJourney[newActiveStep]?.activeStepNo;
      }
      setActiveStepNo(activeStepObjNo ? activeStepObjNo : 0);

      if (checkoutDetails.postCheckoutCurrentStep !== activeStep) {
        setCurrentStep(activeStep);
      }
    }
    let bucket = getLeadBucket(activeStep, journey);
    setHelpLeadBucket(bucket);
  }, [activeStep]);

  function setCurrentStep(step) {
    if (
      step == "login" ||
      step == "payment" ||
      step == "paymentRedirect" ||
      step == "paymentError" ||
      step == "orderConfirmation" ||
      step == "pageError"
    ) {
      if (
        checkoutDetails.skipCreditVetting &&
        checkoutDetails.postCheckoutCurrentStep &&
        authDetailsData &&
        step == "pageError"
      ) {
        if (journey == journeyType.newLine) {
          //Redirect user to the XDS/review page if the selected deal is affordable
          let newStep = authDetailsData?.idType == "SAID" ? "xds" : "review";
          setPostCheckoutCurrentStep(newStep);
          activeStepRef.current = newStep;
        }
      } else {
        //Reset step
        setPostCheckoutCurrentStep(null);
        //Browser back button redirects to cart on error if step is authentication- in handleBackStep function
        activeStepRef.current = "authentication";
      }
    } else {
      setPostCheckoutCurrentStep(step);
      activeStepRef.current = step;
    }
  }

  const browserBackButton = (e) => {
    if (activeStepRef.current) {
      e.preventDefault();
      e.stopPropagation();
      handleBackStep();
    }
  };

  useEffect(() => {
    window.addEventListener("popstate", browserBackButton);
    return () => {
      window.removeEventListener("popstate", browserBackButton);
    };
  }, []);

  /**
   * Set the step tracker as per journey context
   */
  const setJourneyStepTracker = (type) => {
    //Set the customer status(nc,ec,upgrade) value as per journey
    getCustomerStatus(type);

    if (type == journeyType.upgrade) {
      steps.all =
        cartDetails?.isMulti && paymentOptionsEnabled
          ? CHECKOUT_CONFIG.upgradeStepsTrackerWithPayment
          : CHECKOUT_CONFIG.upgradeStepsTracker;
      steps.width = "step-width-65"; //upgradeStepsTracker
    } else {
      steps.all =
        numberTransferEnabled && cartDetails?.isMulti && paymentOptionsEnabled
          ? CHECKOUT_CONFIG.newLineStepsTrackerWithNumberTransferPayment
          : numberTransferEnabled
          ? CHECKOUT_CONFIG.newLineStepsTrackerWithNumberTransfer
          : cartDetails?.isMulti && paymentOptionsEnabled
          ? CHECKOUT_CONFIG.newLineStepsTrackerWithPayment
          : CHECKOUT_CONFIG.newLineStepsTracker;
      steps.width =
        numberTransferEnabled || (cartDetails?.isMulti && paymentOptionsEnabled)
          ? "step-width-75"
          : "step-width-65";
    }

    setState({
      ...state,
      steps,
    });
  };

  /**
   * Disable back button
   */
  const setDisableBackButton = (status) => {
    button.disable = status;

    setState({
      ...state,
      button,
    });
  };

  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */
  const fetchErrorDetails = async () => {
    // const pageName = `checkout: pre val: ${customerStatus}: merge cart`;

    try {
      showSpinner();
      // const result = await ajaxService.httpGet(
      //   "drupalBaseUrl",
      //   "",
      //   "api",
      //   "mergeCartError"
      // );
        
      handleClearCartAndCheckout(
        null,
        "checkout: cart read issue",
        "Clear cart",
        "pageError"
      );

      setPageErr({
        type: "error",
        title: labels.errors.lbl_something_went_wrong,
        desc: "There seems to be issue with cart. Please try again",
        primaryLabel: "Browse deals",
        handlePrimaryClick: async () => { 
          await router.push(`${urlPrefix}/deals`);
        },
        handleSecondaryClick: () => {},
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: `checkout: cart read issue`,
      });
      hideSpinner();
      //Navigate to checkout page error
      handleNextStep("pageError");


      // setPageErr({
      //   type: "error",
      //   title: result[0].resultTitle,
      //   desc:
      //     result[0].resultText && result[0].resultText !== ""
      //       ? result[0].resultText
      //       : result[0].resultHTML,
      //   primaryLabel:
      //     result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
      //   primaryUrl:
      //     result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
      //   secondaryLabel:
      //     result[0].secondaryEnabled === "Yes"
      //       ? result[0].secondaryCTAText
      //       : null,
      //   secondaryUrl:
      //     result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
      //   handlePrimaryClick: () =>
      //     handleClearCartAndCheckout(
      //       result[0].primaryCTAURL,
      //       pageName,
      //       result[0].primaryCTAText
      //     ),
      //   handleSecondaryClick: () =>
      //     handleSecondaryClick(
      //       generateFormURL(
      //         result[0].secondaryCTAURL,
      //         result[0].leadType,
      //         result[0].secondaryCTAType
      //       ),
      //       pageName,
      //       result[0].secondaryCTAText
      //     ),
      //   imgUrl: result[0].icon,
      //   pageName: pageName,
      // });
      // hideSpinner();
      // //Navigate to checkout page error
      // handleNextStep("pageError");
    } catch {
      
      // setPageErr({
      //   type: "error",
      //   title: labels.checkout.lbl_merge_cart_error_title,
      //   desc: labels.checkout.lbl_merge_cart_error_desc,
      //   primaryLabel: "Clear cart & continue with checkout",
      //   secondaryLabel: "View my cart",
      //   handlePrimaryClick: () =>
      //     handleClearCartAndCheckout(
      //       null,
      //       pageName,
      //       "Clear cart & continue with checkout"
      //     ),
      //   handleSecondaryClick: () =>
      //     handleSecondaryClick(null, pageName, "View my cart"),
      //   imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
      //   pageName: pageName,
      // });
      
      handleClearCartAndCheckout(
        null,
        "checkout: cart read issue",
        "Clear cart",
        "pageError"
      );

      setPageErr({
        type: "error",
        title: labels.errors.lbl_something_went_wrong,
        desc: "There seems to be issue with cart. Please try again",
        primaryLabel: "Browse deals",
        handlePrimaryClick: async () => {
          await router.push(`${urlPrefix}/deals`);
        },
        handleSecondaryClick: () => {},
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: `checkout: cart read issue`,
      });
      hideSpinner();
      //Navigate to checkout page error
      handleNextStep("pageError");
    }
  };

  const handleClearCartAndCheckout = async (url, pageName, label, action) => {
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
    });
    showSpinner();
    const nonVasProducts = cartDetails?.cartProductItems.filter(
      (item) => !item?.parent_product_sku
    );
    const cartItemsIds = nonVasProducts.map((item) => item?.id);
    let query = getClearCartQuery(cartItemsIds);

    await ajaxService.fetchGraphQLPOSTRequest(query);

    await showGuestCart(cartId);

    const dealGuestProducts = cartDetails.guestCartItems.filter(
      (item) => item?.product?.is_deal_product === 1
    );

    const simpleProducts = cartDetails.guestCartItems.filter(
      (item) =>
        !item?.monthly_recurring &&
        item?.product?.__typename === labels.lbl_product_typeName_simple &&
        !checkIsOutOfStock(item)
    );
    const configurableProducts = cartDetails.guestCartItems.filter(
      (item) =>
        item?.product?.__typename ===
          labels.lbl_product_typeName_configurable && !checkIsOutOfStock(item)
    );
    const bundledProduct = cartDetails.guestCartItems.filter(
      (item) =>
        item?.product?.is_deal_product === 0 &&
        !item?.monthly_recurring &&
        item?.product?.__typename === labels.lbl_product_type_bundle &&
        !checkIsOutOfStock(item)
    );

    const vasProduct = cartDetails.guestCartItems.filter(
      (item) =>
        item?.parent_product_sku === dealGuestProducts?.[0]?.product?.sku
    );

    let valueString, optionId, cartItemsArr;

    if (isArrayNotEmpty(dealGuestProducts)) {
      cartItemsArr = dealGuestProducts.map((item) => {
        valueString = item?.bundle_custom_options[0]?.values[0]?.value;
        optionId = item?.product?.options[0]?.option_id;
        const bundleOptions = item?.product?.items.map((bundle) => {
          const values = bundle?.options.map((option) => option.id);
          const obj = {
            id: bundle?.option_id,
            quantity: labels.lbl_cart_min_product_add_qty,
            value: values,
          };
          return obj;
        });
        const cartObj = {
          bundle_options: bundleOptions,
          data: {
            sku: `${item?.product?.sku}`.toString(),
            quantity: item?.quantity,
          },
          customizable_options: getCustomizableOptions(optionId, valueString),
        };
        return cartObj;
      });
      let vasArray;
      if (isArrayNotEmpty(vasProduct)) {
        vasArray = vasProduct.map((item) => {
          const vasData = {
            data: {
              sku: item?.product?.sku,
              quantity: item?.quantity,
            },
            parent_product_sku:
              `${dealGuestProducts?.[0]?.product?.sku}`.toString(),
            monthly_recurring: item?.monthly_recurring,
            customizable_options: getCustomizableOptions(optionId, valueString),
            bundle_options: [],
          };

          return vasData;
        });
      }
      if (isArrayNotEmpty(vasArray)) {
        cartItemsArr = [...cartItemsArr, ...vasArray];
      }
      await addBundleProductToGuestCart(cartId, cartItemsArr);
    }
    if (isArrayNotEmpty(simpleProducts)) {
      cartItemsArr = simpleProducts.map((item) => {
        valueString = item?.simple_custom_options[0]?.values[0]?.value;
        optionId = item?.product?.options[0]?.option_id;
        const obj = {
          data: {
            quantity: item?.quantity,
            sku: item?.product?.sku,
          },
          customizable_options: getCustomizableOptions(optionId, valueString),
        };
        return obj;
      });

      await addSimpleProductToGuestCart(cartId, cartItemsArr);
    }
    if (isArrayNotEmpty(configurableProducts)) {
      cartItemsArr = configurableProducts.map((item) => {
        valueString = item?.config_custom_options[0]?.values[0]?.value;
        optionId = item?.product?.options[0]?.option_id;

        const getLabel = (label) => {
          const headingObj = item?.product?.configurable_options.find(
            (config) => config.label === label
          );
          return headingObj?.attribute_code;
        };
        let optionObj = {};
        item?.configurable_options.forEach((addedOption) => {
          optionObj[getLabel(addedOption.option_label)] =
            addedOption.value_label;
        });
        const selectedVariant = getSelectedVariant(
          item?.product?.variants,
          optionObj
        );

        const obj = {
          parent_sku: `${item?.product?.sku}`.toString(),
          data: {
            quantity: item?.quantity,
            sku: `${selectedVariant?.product?.sku}`.toString(),
          },
          customizable_options: getCustomizableOptions(optionId, valueString),
        };
        return obj;
      });
      await addConfigurableToGuestCart(cartId, cartItemsArr);
    }
    if (isArrayNotEmpty(bundledProduct)) {
      cartItemsArr = bundledProduct.map((item) => {
        valueString = item?.bundle_custom_options[0]?.values[0]?.value;
        optionId = item?.product?.options[0]?.option_id;

        const bundleOptions = item?.product?.items.map((bundle) => {
          const obj = {
            id: bundle?.option_id,
            quantity: labels.lbl_cart_min_product_add_qty,
            value: [bundle?.options[0].id],
          };

          return obj;
        });

        const cartObj = {
          bundle_options: bundleOptions,
          data: {
            sku: `${item?.product?.sku}`.toString(),
            quantity: item?.quantity,
          },
          customizable_options: getCustomizableOptions(optionId, valueString),
        };

        return cartObj;
      });

      await addBundleProductToGuestCart(cartId, cartItemsArr);
    }
    if (isArrayNotEmpty(cartDetails.guestCoupons)) {
      const code = cartDetails?.guestCoupons[0]?.code;
      await addCouponToCart(cartId, code);
    }
    addGuestCartProducts([], 0);
    hideSpinner();
    if(action){
      handleNextStep(action);
    }
    else{
      handleNextStep("authentication");
    }
    
  };

  const handleSecondaryClick = (url, pageName, label, _skipUrlPrefix) => {
    showSpinner();
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
    });
    addGuestCartProducts([], 0, null);
    if (url) {
      router.push(`${urlPrefix}${url}`).then(() => {
        hideSpinner();
      });
    } else {
      router.push(`${urlPrefix}/cart`).then(() => {
        hideSpinner();
      });
    }
  };

  async function fetchAddressStateTypes() {
    let resultsStates = await getSAStatesService();
    let resultsAddressTypes = await getAddressTypesService();

    if (resultsStates) {
      if (!resultsStates.fail) {
        setCountryCode(resultsStates.countryRegions.countryCode);
        setCountryName(resultsStates.countryRegions.countryName);
        setRegions(resultsStates.countryRegions.regions);
      }

      if (resultsStates.errors) {
        Analytics.link({
          ...Analytics.getUtagData(["page_name"]),
          page_form_event: "error",
          page_errors: `${
            resultsStates.errors[0] ? resultsStates.errors?.[0].message : ""
          }`,
          page_errors_code: `chk-dxl-g-states-${resultsStates.status}`,
        });
      }
    }

    if (resultsAddressTypes) {
      if (!resultsAddressTypes.fail) {
        setAddressTypes(resultsAddressTypes.addressTypeData);
      }

      if (resultsAddressTypes.errors) {
        Analytics.link({
          ...Analytics.getUtagData(["page_name"]),
          page_form_event: "error",
          page_errors: `${
            resultsAddressTypes.errors[0]
              ? resultsAddressTypes.errors?.[0].message
              : ""
          }`,
          page_errors_code: `chk-dxl-g-at-${resultsAddressTypes.status}`,
        });
      }
    }
  }

  async function fetchFaqData() {
    let resultsFaq = await ajaxService.httpGet(
      "drupalBaseUrl",
      "",
      "api",
      "checkoutFaq"
    );

    if (resultsFaq?.status == "success") {
      let len = resultsFaq.sections.length;

      for (let i = 0; i < len; i++) {
        if (resultsFaq.sections[i]) {
          if (
            resultsFaq.sections[i].type == "paragraph_list" &&
            resultsFaq.sections[i].paragraphInfo == "form"
          ) {
            setFormContent(resultsFaq.sections[i]);
          }

          if (
            resultsFaq.sections[i].type == "paragraph_list" &&
            resultsFaq.sections[i].paragraphInfo == "sidebar"
          ) {
            setSidebarContent(resultsFaq.sections[i]);
          }

          if (resultsFaq.sections[i].type == "faq") {
            setFaq(resultsFaq.sections[i]);
          }

          if (
            resultsFaq.sections[i].type == "paragraph_list" &&
            resultsFaq.sections[i].paragraphInfo == "sidebar-notification"
          ) {
            setNotificationContent(resultsFaq.sections[i]?.items[0]);
          }
        }
      }
    }
  }

  // Redirecting to order confirmation page on payment success
  useEffect(() => {
    if (userLoggedIn) {      
      checkUserPickedDetails();
      if (Object.keys(paymentStatus).length > 0 && orderId) {
        setLabels(null);
        setActiveStep(null);
        callVerifyStatus();
      } else {
        Cookie.remove(config.order_id);
        Cookie.remove(config.pay_fail_count);
      }
      Analytics.setAutoTagging(false);
    }
  }, [paymentStatus, userLoggedIn]);

  const checkUserPickedDetails = () => {
    const sessionCartSummary = getSessionStorage(labels.Session_Keys.lbl_cart_summary);
    if(!sessionCartSummary){      
      handleClearCartAndCheckout(
        null,
        "checkout: cart read issue",
        "Clear cart",
        "pageError"
      );
      setPageErr({
        type: "error",
        title: labels.errors.lbl_something_went_wrong,
        desc: "There seems to be issue with cart. Please try again",
        primaryLabel: "Browse deals",
        handlePrimaryClick: async () => {         
          await router.push(`${urlPrefix}/deals`);
        },
        handleSecondaryClick: () => {},
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: `checkout: cart read issue`,
      });  
      handleNextStep("pageError");
    }    
  }

  const callVerifyStatus = () => {
    showSpinner();
    const headers = {
      "Content-Type": "application/json",
    };
    const url = `${config.envConfigs[config.env].dxl.url}${
      config["api"]["verifyPayment"]
    }`;
    axios
      .post(url, paymentStatus?.params, {
        headers: headers,
      })
      .then((response) => {
        hideSpinner();
        if (
          response?.data?.result?.successful ||
          paymentStatus?.params?.ErrorCode == "00"
        ) {
          Cookie.remove(config.pay_fail_count);
          setPaymentMethodUrl(null);
          setPostOrderResponse({});
          handleNextStep("orderConfirmation");
        } else {
          updatePaymentRetryCount();
          handleNextStep("paymentError");
        }
      })
      .catch((_err) => {
        hideSpinner();
        Cookie.remove(config.order_id);
        Cookie.remove(config.pay_fail_count);
        setPaymentMethodUrl(null);
        setPostOrderResponse({});

        if (paymentStatus?.params?.ErrorCode !== "00" || paymentStatus?.error) {
          if (previewMode) {
            handleNextStep("authentication");
          } else {
            setPageErr({
              type: "error",
              title: labels.errors.lbl_something_went_wrong,
              desc: labels.lbl_checkout_unavailable,
              primaryLabel: null,
              secondaryLabel: "Exit checkout",
              handlePrimaryClick: () => {},
              handleSecondaryClick: () =>
                handleSecondaryClick(
                  "/cart",
                  `checkout: make payment: ${customerStatus}`,
                  "exit"
                ),
              imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
              pageName: `checkout: make payment: ${customerStatus}`,
            });

            handleNextStep("pageError");
          }
        } else {
          handleNextStep("authentication");
        }
      });
  };

  const updatePaymentRetryCount = () => {
    const retryCount = getCookieValue(config.pay_fail_count);
    const newCount = retryCount ? parseInt(retryCount) + 1 : 0;
    setCookieConsentWrapper(
      `cookie_${config.pay_fail_count}`,
      [config.cookie_category.strictly_necessary],
      `document.cookie='${config.pay_fail_count}=${newCount};path=/'`
    );
  };

  useEffect(() => {
    if (cartIdCookie) {
      setCartId(cartIdCookie);
    }
  }, [cartIdCookie]);

  useEffect(() => {
    async function getSeoData() {
      const results = await pageAPI.getPageComponents([
        `checkout/CBU${
          previewMode
            ? config.pageServiceQueryData.preview
            : config.pageServiceQueryData.status
        }`,
      ]);
      setMetaData(results?.seoMetadata);

      if (results && results.status === "error") {
        Analytics.link({
          page_name: `checkout: ${customerStatus}`,
          page_form_event: "error",
          page_errors: `${results.reason ? results.reason : ""}`,
          page_errors_code: `chck-d-g-seo`,
        });
      }
    }
    getSeoData();
  }, []);

  function getCustomerStatus(type) {
    if (type == journeyType.upgrade) {
      setCustomerStatus("upgrade");
    } else if (type == journeyType.newLine) {
      setCustomerStatus("nc");
    } else {
      setCustomerStatus("ec");
    }
  }

  useEffect(() => {
    const { allow_place_order } = cartDetails;
    if (
      typeof allow_place_order !== "undefined" &&
      Number(allow_place_order) === 0
    ) {
      setPageErr({
        type: "error",
        title: labels.errors.lbl_something_went_wrong,
        desc: labels.lbl_checkout_unavailable,
        primaryLabel: null,
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: () => {
          return handlePrimaryClick("/cart", "exit checkout");
        },
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: `checkout: lets get started: ${customerStatus}`,
      });
      setAllowPlaceOrder(false);
      handleNextStep("pageError");
    } else {
      setAllowPlaceOrder(true);
    }
  }, [cartDetails?.allow_place_order]);

  const onClickSubmit = () => {
    if (
      allowPlaceOrder &&
      !continueDisabled &&
      postCheckoutPageRef.current &&
      postCheckoutPageRef.current.submit
    ) {
      if (
        cartDetails?.isMulti &&
        creditVettingDetails &&
        (creditVettingDetails?.resultCode ===
          labels.creditVetting.lbl_resultcode_pended ||
          creditVettingDetails?.resultCode ===
            labels.creditVetting.lbl_resultcode_pending ||
          creditVettingDetails?.resultCode ===
            labels.creditVetting.lbl_resultcode_referred ||
          creditVettingDetails?.resultCode ===
            labels.creditVetting.lbl_resultcode_offline ||
          creditVettingDetails?.resultCode
            ?.toUpperCase()
            .includes(labels.creditVetting.lbl_unprocessed))
      ) {
        setShowOnceOff(false); //hide once-off info in the Checkout Order Summary
      } else {
        setShowOnceOff(true);
      }

      postCheckoutPageRef.current.submit();
    }
  };

  const handleNextStep = (newStep) => {
    setLabels(newStep);
    setActiveStep(newStep);

    if (
      newStep !== "login" &&
      newStep !== "authentication" &&
      newStep !== "paymentRedirect" &&
      newStep !== "paymentError" &&
      newStep !== "orderConfirmation" &&
      newStep !== "pageError"
    ) {
      history.pushState({ name: newStep }, null, window.location.pathname);
    } else {
      history.pushState(null, null, window.location.pathname);
    }
  };

  const handleBackStep = async () => {
    let currentActiveStep = activeStep ? activeStep : activeStepRef.current;

    if (postCheckoutPageRef.current && postCheckoutPageRef.current.back) {
      postCheckoutPageRef.current.back();
    }

    if (
      currentActiveStep == "authentication" ||
      currentActiveStep == "creditCheck"
    ) {
      showSpinner();
      await router.push(`${urlPrefix}/cart`);
      hideSpinner();
    } else {
      refreshState();
      if (
        currentActiveStep == "review" &&
        journey !== journeyType.upgrade &&
        checkoutDetails.skipCreditVetting
      ) {
        //Redirect to let's get started page
        handleNextStep("authentication");
      } else {
        let previousStep = currentActiveStep;
        if (journey == journeyType.upgrade) {
          previousStep =
            cartDetails?.isMulti && paymentOptionsEnabled
              ? CHECKOUT_CONFIG.upgradeJourneyWithPayment[currentActiveStep]
                  ?.prevStep
              : CHECKOUT_CONFIG.upgradeJourney[currentActiveStep]?.prevStep;
        } else {
          previousStep =
            numberTransferEnabled &&
            cartDetails?.isMulti &&
            paymentOptionsEnabled
              ? CHECKOUT_CONFIG.newLineJourneyWithNumberTransferPayment[
                  currentActiveStep
                ]?.prevStep
              : numberTransferEnabled
              ? CHECKOUT_CONFIG.newLineJourneyWithNumberTransfer[
                  currentActiveStep
                ]?.prevStep
              : cartDetails?.isMulti && paymentOptionsEnabled
              ? CHECKOUT_CONFIG.newLineJourneyWithPayment[currentActiveStep]
                  ?.prevStep
              : CHECKOUT_CONFIG.newLineJourney[currentActiveStep]?.prevStep;
        }

        setLabels(previousStep);
        setActiveStep(previousStep);
      }
    }
  };

  const handlePrimaryClick = (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    if (url) {
      router.push(`${urlPrefix}${url}`).then(() => {
        hideSpinner();
      });
    } else {
      router.push(`${urlPrefix}/cart`).then(() => {
        hideSpinner();
      });
    }
  };

  const setLabels = (step) => {
    switch (step) {
      case "login":
        heading.title = "How would you like to check out?";
        heading.titleClass = "login-title";
        heading.desc = "";
        heading.descClass = "login-desc";
        heading.id = "login";
        heading.class = "login";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back to cart";
        button.backButtonId = "back-login";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = false;
        break;
      case "authentication":
        heading.title = "Let’s get started";
        heading.titleClass = "authentication-title";
        heading.desc = "";
        heading.descClass = "authentication-desc";
        heading.id = "authentication";
        heading.class = "authentication";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-authentication";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = false;
        break;
      case "otp":
        heading.title = "Authorise this upgrade";
        heading.titleClass = "otp-title";
        heading.desc =
          "We’ve sent a One-Time PIN (OTP) to 082****123 in order for you to authorise this upgrade";
        heading.descClass = "otp-desc";
        heading.id = "otp";
        heading.class = "otp";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-otp";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;
      case "xds":
        heading.title = "Authentication questions";
        heading.titleClass = "xds-title";
        heading.desc =
          "For your protection, please answer the following questions to authenticate this application.";
        heading.descClass = "xds-desc d-none";
        heading.id = "xds";
        heading.class = "xds";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-xds";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;
      case "creditCheck":
        heading.title = "Credit check";
        heading.titleClass = "credit-check-title";
        heading.desc =
          "In order to process your application, we’ll need the following information to submit a credit check";
        heading.descClass = "credit-check-desc";
        heading.id = "credit-check";
        heading.class = "credit-check";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-credit-check";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;
      case "numberTransfer":
        heading.title = "Transfer a prepaid number";
        heading.titleClass = "number-transfer-title";
        heading.desc = "";
        heading.descClass = "number-transfer-desc";
        heading.id = "number-transfer";
        heading.class = "number-transfer";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-number-transfer";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;
      case "delivery":
        heading.title = "Delivery details";
        heading.titleClass = "delivery-title";
        heading.desc = "";
        heading.descClass = "delivery-desc";
        heading.id = "delivery";
        heading.class = "delivery";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-delivery";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;
      case "review":
        heading.title = "Review your order";
        heading.titleClass = "review-title";
        heading.desc = "Make sure you're 100% happy before continuing";
        heading.descClass = "review-desc";
        heading.id = "review";
        heading.class = "review";
        button.secure = false;
        button.payment = true;
        button.lable =
          cartDetails?.isMulti && paymentOptionsEnabled
            ? "Continue"
            : journey == journeyType.upgrade
            ? "Submit upgrade"
            : "Submit application";
        button.backLable = "Back";
        button.backButtonId = "back-review";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = true;
        break;
      case "payment":
        heading.title = "Payment";
        heading.titleClass = "payment-title";
        heading.desc = "";
        heading.descClass = "payment-desc";
        heading.id = "payment";
        heading.class = "payment";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-payment";
        button.backButtonClass = "";
        button.disable = true;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;
      case "paymentRedirect":
        heading.title = "";
        heading.titleClass = "payment-redirect-title";
        heading.desc = "";
        heading.descClass = "payment-redirect-desc";
        heading.id = "payment-redirect";
        heading.class = "payment-redirect";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-payment-redirect";
        button.backButtonClass = "";
        button.disable = true;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;
      case "orderConfirmation":
        heading.title = "Order confirmation";
        heading.titleClass = "order-confirmation-title";
        heading.desc = "";
        heading.descClass = "order-confirmation-desc";
        heading.id = "order-confirmation";
        heading.class = "order-confirmation";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-order-confirmation";
        button.backButtonClass = "d-none";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = true;
        break;
      default:
        heading.title = "";
        heading.titleClass = "";
        heading.desc = "";
        heading.descClass = "";
        heading.id = "";
        heading.class = "";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back to cart";
        button.backButtonId = "back-cart";
        button.backButtonClass = "d-none";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = false;
        break;
    }
    setState({
      ...state,
      heading,
      button,
      orderSummery,
      steps,
    });
  };

  const checkContinueDisableStatus = (status) => {
    setContinueDisabled(status);
  };

  const refreshState = () => {
    setContinueDisabled(true);
  };

  const hideLoginModal = async () => {
    showSpinner();
    setShowLoginModal(false);
    await router.push(`${urlPrefix}/cart`);
    hideSpinner();
  };

  const loginUrl = config.envConfigs[env].DIDLoginUrl;
  const isMiniApp = getCookieValue("miniApp") === "true";

  const hideErrorModal = () => {
    showSpinner();
    hideSpinner();
    window.location = loginUrl + "?redirectUrl=" + redirectURL + (isMiniApp ? "&app=true" : "");
  };

  const handleHeading = (type, section, value) => {
    let classStr = section == "title" ? "titleClass" : "descClass";
    if (Object.prototype.hasOwnProperty.call(heading, section)) {
      if (type == "update") {
        heading[section] = value;
      } else if (type == "hide") {
        heading[classStr] = "d-none";
      } else {
        heading[classStr] = heading.id + "-" + section;
      }
      setState({
        ...state,
        heading,
      });
    }
  };

  const leadSubmissonContent = async () => {
    const result = await ajaxService.httpGet(
      "drupalBaseUrl",
      "",
      "api",
      "errorResultDetails",
      ["NXTLVLLeadSubmitted_multicart"]
    );
    return result;
  };

  const handlePrimaryNxtLvlClick = async () => {
    showSpinner();
    let pageName = `checkout: credit check: ${customerStatus}: nxt lvl`;
    let label = "call me";

    const nexLvlMulticartFormPayload = {
      channel: "ONLINE",
      requestType: "next_level_cust",
      idNumber: authDetailsData?.idNumber ? authDetailsData?.idNumber : "",
      idDocType: "SAID",
      name: personalDetailsData?.firstName
        ? personalDetailsData?.firstName
        : "",
      surname: personalDetailsData?.surName ? personalDetailsData?.surName : "",
      msisdn: africaCountryCode(authDetailsData?.msisdn)
        ? authDetailsData?.msisdn
        : appendCountryCode(authDetailsData?.msisdn),
      emailAddress: contactDetailsData?.emailAddress,
    };

    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
    });

    try {
      const formResponse = await microService.post(
        "api",
        "staticFormSubmit",
        nexLvlMulticartFormPayload,
        null,
        false
      );
      const formResult = formResponse.response?.data?.result;

      if (formResult?.successful) {
        const result = await leadSubmissonContent();
        setPageErr({
          type: "error",
          title: result[0].resultTitle,
          desc: cartDetails?.billing_address?.telephone
            ? `${
                labels.order_messages_labels.lbl_consultant_phone
              } ${maskMsisdn(cartDetails?.billing_address?.telephone)}`
            : result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML,
          primaryLabel: result[0].primaryEnabled
            ? result[0].primaryCTAText
            : null,
          secondaryLabel: result[0].secondaryEnabled
            ? result[0].secondaryCTAText
            : null,
          handlePrimaryClick: () =>
            handleSecondaryClick(
              result[0].primaryCTAURL,
              pageName,
              "exit",
              true
            ),
          imgUrl: result[0].icon,
          pageName,
        });
        hideSpinner();
        handleNextStep("pageError");
      } else {
        if (formResponse?.error?.status) {
          fetchErrorDetails(
            `creditVettingOutcome_${formResponse?.error?.status}`
          );
        } else {
          fetchErrorDetails(labels.auth.errorCodes.api_time_out);
        }
      }
    } catch (error) {
      hideSpinner();
    } finally {
      removeCreditCheckStates(null);
    }
  };

  const replaceStaticAmount = (str, amount) => {
    if (str && str !== "" && amount && str.match(/{{amount}}/g)) {
      return str.replace("{{amount}}", amount);
    } else {
      return str;
    }
  };

  //Will be replaced with React components
  const stepLogin = (
    <div>
      {profileSyncFail ?
            <SyncError
              navigate={handleNextStep}
              handleCancel={hideErrorModal}
            />
        : (
        <LoginModal
          show={showLoginModal}
          handleCancel={hideLoginModal}
          navigate={handleNextStep}
          applicationType="normal"
          redirectTo={redirectURL}
          setGuestCart={() =>
            addGuestCartProducts(
              cartItems,
              cartDetails.totalQuantity,
              cartDetails.applied_coupons
            )
          }
          resetGuestCart={() => addGuestCartProducts([], 0, null)}
        />
      )}
    </div>
  );

  const stepAuthentication = (
    <CheckoutAuthentication
      ref={postCheckoutPageRef}
      formContent={formContent}
      userLoggedIn={userLoggedIn}
      profileData={profileData ? profileData : null}
      authDetails={authDetails ? authDetails : null}
      customerStatus={customerStatus}
      dealID={dealID}
      contractType={contractType}
      navigate={handleNextStep}
      setShowSnackBar={setShowSnackBar}
      setPageErr={setPageErr}
      setJourneyStepTracker={setJourneyStepTracker}
      features={features}
      multicartFlag={cartDetails?.isMulti}
      handlePrimaryNxtLvlClick={handlePrimaryNxtLvlClick}
    />
  );
  const stepOtp = (
    <CheckoutMahAuthentication
      ref={postCheckoutPageRef}
      userLoggedIn={userLoggedIn}
      profileData={profileData ? profileData : null}
      authDetails={authDetails ? authDetails : null}
      customerStatus={customerStatus}
      dealID={dealID}
      contractType={contractType}
      continueDisable={checkContinueDisableStatus}
      navigate={handleNextStep}
      setShowTooltip={setShowSnackBar}
      setPageErr={setPageErr}
      setJourneyStepTracker={setJourneyStepTracker}
      handleHeading={handleHeading}
      currentJourney={journey}
      multicartFlag={cartDetails?.isMulti}
      numberTransferEnabled={numberTransferEnabled}
    />
  );
  const stepXds = (
    <CheckoutXds
      ref={postCheckoutPageRef}
      checkoutDetails={checkoutDetails}
      continueDisable={checkContinueDisableStatus}
      userLoggedIn={userLoggedIn}
      profileData={profileData ? profileData : null}
      authDetails={authDetails ? authDetails : null}
      customerStatus={customerStatus}
      navigate={handleNextStep}
      setShowSnackBar={setShowSnackBar}
      handleHeading={handleHeading}
      multicartFlag={cartDetails?.isMulti}
    />
  );
  const stepCreditCheck = (
    <CheckoutCreditCheck
      ref={postCheckoutPageRef}
      continueDisable={checkContinueDisableStatus}
      userLoggedIn={userLoggedIn}
      profileData={profileData ? profileData : null}
      authDetails={authDetails ? authDetails : null}
      customerStatus={customerStatus}
      addressTypes={addressTypes}
      statesTypes={regions}
      shippingAddress={shippingAddress ? shippingAddress : null}
      countryCode={countryCode}
      countryName={countryName}
      setShowSnackBar={setShowSnackBar}
      navigate={handleNextStep}
      setPageErr={setPageErr}
      setDisableBackButton={setDisableBackButton}
      handleHeading={handleHeading}
      carrierCode={carrierCode}
      methodCode={methodCode}
      dealCategoryId={dealCategoryId}
      currentJourneyType={journey}
      multicartFlag={cartDetails?.isMulti}
      numberTransferEnabled={numberTransferEnabled}
      setShowOnceOff={setShowOnceOff}
    />
  );
  const stepNumberTransfer = (
    <NumberTransfer
      ref={postCheckoutPageRef}
      continueDisable={checkContinueDisableStatus}
      navigate={handleNextStep}
      setShowSnackBar={setShowSnackBar}
      handleHeading={handleHeading}
      customerStatus={customerStatus}
      currentJourneyType={journey}
      multicartFlag={cartDetails?.isMulti}
    />
  );
  const stepDelivery = (
    <CheckoutDelivery
      ref={postCheckoutPageRef}
      continueDisable={checkContinueDisableStatus}
      addressTypes={addressTypes}
      statesTypes={regions}
      countryCode={countryCode}
      countryName={countryName}
      cartId={cartId}
      navigate={handleNextStep}
      shippingMessageText={shippingMessageText}
      shippingFeeCalculateAmount={shippingFeeCalculateAmount}
      subTotal={
        allPrices &&
        allPrices.subtotal_including_tax &&
        allPrices.subtotal_including_tax.value
          ? allPrices.subtotal_including_tax.value
          : 0
      }
      shippingAddress={shippingAddress ? shippingAddress : null}
      billingAddress={billingAddress ? billingAddress : null}
      isGuestUser={userLoggedIn ? false : true}
      profileData={profileData ? profileData : null}
      authDetails={authDetails ? authDetails : null}
      customerStatus={customerStatus}
      setShowSnackBar={setShowSnackBar}
      setPageErr={setPageErr}
      carrierCode={carrierCode}
      methodCode={methodCode}
      applicationType="contract"
      currentJourneyType={journey}
      clickAndCollectDelivery={clickAndCollectDelivery}
      dealID={primaryProductSku}
      clickAndCollectEnabled={clickAndCollectEnabled}
    />
  );
  const stepReview = (
    <CheckoutReview
      ref={postCheckoutPageRef}
      cartProducts={cartItems}
      continueDisable={checkContinueDisableStatus}
      addressTypes={addressTypes}
      statesTypes={regions}
      countryCode={countryCode}
      countryName={countryName}
      cartId={cartId}
      navigate={handleNextStep}
      totalPrice={
        allPrices && allPrices.grand_total && allPrices.grand_total.value
          ? allPrices.grand_total.value
          : 0
      }
      totalQuantity={cartDetails.totalQuantity ? cartDetails.totalQuantity : 0}
      shippingAddress={shippingAddress ? shippingAddress : null}
      userLoggedIn={userLoggedIn}
      profileData={profileData}
      authDetails={authDetails}
      customerStatus={customerStatus}
      applicationType="contract"
      currentJourneyType={journey}
      cartDetails={cartDetails}
    />
  );
  const stepPayment = (
    <CheckoutPayment
      ref={postCheckoutPageRef}
      continueDisable={checkContinueDisableStatus}
      cartId={cartId}
      navigate={handleNextStep}
      userLoggedIn={userLoggedIn}
      profileData={profileData}
      authDetails={authDetails}
      paymentConfiguration={paymentConfiguration}
      customerStatus={customerStatus}
      applicationType="contract"
      currentJourneyType={journey}
      cartDetails={cartDetails}
    />
  );
  const stepPaymentRedirect = (
    <PaymentRedirect
      navigate={handleNextStep}
      customerStatus={customerStatus}
      userLoggedIn={userLoggedIn}
      profileData={profileData}
      authDetails={authDetails}
      paymentConfiguration={paymentConfiguration}
      applicationType="contract"
      paymentOptionsEnabled={paymentOptionsEnabled}
    />
  );
  const stepPaymentError = (
    <CheckoutPaymentError
      navigate={handleNextStep}
      userLoggedIn={userLoggedIn}
      profileData={profileData}
      authDetails={authDetails}
      paymentConfiguration={paymentConfiguration}
      customerStatus={customerStatus}
      applicationType="contract"
      paymentOptionsEnabled={paymentOptionsEnabled}
    />
  );
  const stepOrderConfirmation = (
    <CheckoutOrderConfirmation
      navigate={handleNextStep}
      cartProducts={cartItems}
      userLoggedIn={userLoggedIn}
      profileData={profileData}
      authDetails={authDetails}
      customerStatus={customerStatus}
      setShowSnackBar={setShowSnackBar}
      setPageErr={setPageErr}
      applicationType="contract"
    />
  );
  const stepPageError = (
    <CheckoutPageError
      type={pageErr.type}
      title={pageErr.title}
      desc={pageErr.desc}
      primaryLabel={pageErr.primaryLabel}
      primaryUrl={pageErr.primaryUrl}
      secondaryLabel={pageErr.secondaryLabel}
      secondaryUrl={pageErr.secondaryUrl}
      handlePrimaryClick={pageErr.handlePrimaryClick}
      handleSecondaryClick={pageErr.handleSecondaryClick}
      imgUrl={pageErr.imgUrl}
      pageName={pageErr.pageName}
      pageErrorType={pageErr.pageErrorType}
      additionalUtagData={pageErr.additionalUtagData}
      applicationType="contract"
      dividerLine={pageErr.dividerLine}
      subTitle={pageErr.subTitle}
      subDesc={pageErr.subDesc}
      ctaTitle={pageErr.ctaTitle}
      disablePrimary={pageErr.disablePrimary}
      preferences={pageErr.preferences}
      defaultPreference={pageErr.defaultPreference}
      dealProducts={dealCartProducts}
      cartItems={cartItems}
      multicartFlag={cartDetails?.isMulti}
      analyticsPageErrorCode={pageErr.analyticsPageErrorCode}
      analyticsPageErrorMessage={pageErr.analyticsPageErrorMessage}
      onceOffCartProducts={onceOffCartProducts}
    />
  );

  const renderLeftSectionDisplay = (step) => {
    let display;
    switch (step) {
      case "login":
        display = stepLogin; //replace with React component
        break;
      case "authentication":
        display = stepAuthentication; //replace with React component
        break;
      case "otp":
        display = stepOtp; //replace with React component
        break;
      case "xds":
        display = stepXds; //replace with React component
        break;
      case "creditCheck":
        display = stepCreditCheck; //replace with React component
        break;
      case "numberTransfer":
        display = stepNumberTransfer; //replace with React component
        break;
      case "delivery":
        display = stepDelivery; //replace with React component
        break;
      case "review":
        display = stepReview; //replace with React component
        break;
      case "payment":
        display = stepPayment; //replace with React component
        break;
      case "paymentRedirect":
        display = stepPaymentRedirect; //replace with React component
        break;
      case "paymentError":
        display = stepPaymentError; //replace with React component
        break;
      case "orderConfirmation":
        display = stepOrderConfirmation; //replace with React component
        break;
      case "pageError":
        display = stepPageError; //replace with React component
        break;

      default: //replace with react components
        display = null;
        break;
    }

    return display;
  };

  const renderRightSectionDisplay = (step) => {
    let display;
    switch (step) {
      case "authentication":
        display = (
          <FormRightSidebar
            content={sidebarContent}
            pageName={`checkout: lets get started: ${customerStatus}`}
            formName="faq"
            pageChannel="checkout"
            linkId="see-faq-question-link"
            linkPrevent={true}
          />
        );
        break;

      default:
        display = (
          <>
            <CheckoutOrderSummary
              variant={state.orderSummery.variant}
              btnSecure={state.button.secure}
              btnPayment={state.button.payment}
              btnLable={state.button.lable}
              btnDisabled={continueDisabled || !allowPlaceOrder}
              onClickSubmit={onClickSubmit}
              navigate={handleNextStep}
              monthlyCartProducts={monthlyCartProducts}
              dealProducts={dealCartProducts}
              onceOffCartProducts={onceOffCartProducts}
              contractType={contractType}
              pageType="contract"
              delivery={labels.lbl_free}
              customerStatus={customerStatus}
              setPageErr={setPageErr}
              currentJourneyType={journey}
              shippingAddress={shippingAddress ? shippingAddress : null}
              addressTypes={addressTypes}
              subTotal={onceOffSubTotal}
              total={getCartGrandTotal(cartDetails)}
              cartDetails={cartDetails}
              showOnceOffProducts={showOnceOff}
              activeStep={activeStep}
              buttonPaymentPageName="review order"
              paymentOptionsEnabled={paymentOptionsEnabled}
              continueDisable={checkContinueDisableStatus}
            />
            {cartDetails?.isMulti &&
              showOnceOff &&
              (activeStep === "review" || activeStep === "payment") && (
                <CustomContainer className={styles["notify-wrapper"]}>
                  <NotificationBox
                    className={styles["notify-container"]}
                    img_path={
                      notificationContent
                        ? notificationContent.icon
                        : `${imagePrefix}/assets/images/rect.svg`
                    }
                    labelBold={
                      notificationContent
                        ? replaceStaticAmount(
                            notificationContent.title,
                            onceOffSubTotal
                          )
                        : `You’ll only pay ${onceOffSubTotal} now.`
                    }
                    labelNormal={
                      notificationContent
                        ? notificationContent.description
                        : labels.lbl_multi_onceoff_msg
                    }
                    labelStyling={styles.msg}
                    textStyle={styles["text-style"]}
                    link={false}
                    img_width="1.5rem"
                    img_height="1.5rem"
                  />
                </CustomContainer>
              )}
          </>
        );
        break;
    }

    return display;
  };

  const renderFullSectionDisplay = (step) => {
    let display;

    if (step) {
      switch (step) {
        case "login":
        case "authentication":
          display = (
            <>
              <CustomContainer className={`${styles["top-wrapper"]}`}>
                <PageHeading
                  text={state.heading.title}
                  className={`${styles["top-wrapper__heading"]} ${state.heading.titleClass}
                `}
                  id={`checkout-${state.heading.id}-heading`}
                />
                {state.heading.desc !== "" && (
                  <PageDescription
                    text={state.heading.desc}
                    className={`${styles["top-wrapper__desc"]} ${state.heading.descClass}`}
                    id={`checkout-${state.heading.id}-desc`}
                  />
                )}
              </CustomContainer>

              <CustomContainer
                className={`${styles["post-checkout-main-section"]}`}
              >
                <CustomContainer className={`${styles["left"]}`}>
                  {renderLeftSectionDisplay(step)}
                </CustomContainer>

                <CustomContainer className={`${styles["right"]}`}>
                  {renderRightSectionDisplay(step)}
                </CustomContainer>
              </CustomContainer>
            </>
          );
          break;

        default:
          display = (
            <CustomContainer className={`${styles["main-section"]}`}>
              <CustomContainer className={`${styles["col-left"]}`}>
                <CustomContainer
                  className={`${styles[heading.class]} ${
                    styles["top-wrapper"]
                  }`}
                >
                  <PageHeading
                    text={state.heading.title}
                    className={`${styles["top-wrapper__heading"]} ${state.heading.titleClass}`}
                    id={`checkout-${state.heading.id}-heading`}
                  />
                  {state.heading.desc !== "" && (
                    <PageDescription
                      text={state.heading.desc}
                      className={`${styles["top-wrapper__desc"]} ${state.heading.descClass}`}
                      id={`checkout-${state.heading.id}-desc`}
                    />
                  )}
                </CustomContainer>
                {renderLeftSectionDisplay(step)}
              </CustomContainer>
              <CustomContainer className={`${styles["col-right"]}`}>
                {renderRightSectionDisplay(step)}
              </CustomContainer>
            </CustomContainer>
          );
          break;
      }
    } else {
      display = null;
    }

    return display;
  };

  return (
    <>
      <Seo
        title={metadata?.title}
        content={metadata?.description}
        url={metadata?.canonical_url}
        keywords={metadata?.keywords}
        robots={metadata?.robots}
      />
      <FlagsContext.Provider
        value={{
          vodacomPrepaidTransfer,
          otherPrepaidTransfer,
        }}
      >
        <CheckoutJourneyContext.Provider value={journeyProviderValue}>
          <CheckoutPage
            steps={state.steps.all}
            stepsShow={state.steps.show}
            stepsWidth={state.steps.width}
            activeStep={activeStep}
            activeStepNo={activeStepNo}
            handleNextStep={handleNextStep}
            className={styles[state.heading.class]}
            customerStatus={customerStatus}
            orderSummeryVariant={state.orderSummery.variant}
            faq={activeStep == "authentication" ? faq : null}
            showSnackBar={showSnackBar}
            setShowSnackBar={setShowSnackBar}
            multicartFlag={cartDetails?.isMulti}
          >
            {activeStep !== "login"
              && activeStep !== "paymentRedirect"
              && activeStep !== "paymentError"
              && activeStep !== "orderConfirmation"
              && activeStep !== "pageError"
              ? (
                <ButtonWithIcon
                  className={`${styles["back-button"]} ${state.button.backButtonClass}`}
                  labelText={state.button.backLable}
                  img_url_inactive={`${imagePrefix}/assets/images/caret-back.svg`}
                  img_url_active={`${imagePrefix}/assets/images/caret-back.svg`}
                  img_url_disable={`${imagePrefix}/assets/images/disable-caret-back.svg`}
                  clickHandler={handleBackStep}
                  id={`checkout-${state.button.backButtonId}`}
                  disableBackButton={state.button.disable}
                />
              ) 
              : null
            }

            {activeStep == "login" ||
            activeStep == "paymentRedirect" ||
            activeStep == "paymentError" ||
            activeStep == "orderConfirmation" ||
            activeStep == "pageError" ? (
              renderLeftSectionDisplay(activeStep)
            ) : (
              <CustomContainer
                noGutters={true}
                className={`${styles["main-row"]}`}
              >
                { renderFullSectionDisplay(activeStep) }
              </CustomContainer>
            )}
          </CheckoutPage>
        </CheckoutJourneyContext.Provider>
      </FlagsContext.Provider>
    </>
  );
};

PostCheckout.propTypes = {
  cartId: PropTypes.string,
  dealCategoryId: PropTypes.string,
  numberTransferEnabled: PropTypes.bool,
  cartDetails: PropTypes.object,
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.any,
  authDetails: PropTypes.any,
  paymentConfiguration: PropTypes.any,
  vodacomPrepaidTransfer: PropTypes.bool,
  otherPrepaidTransfer: PropTypes.bool,
  cartProductItems: PropTypes.array,
  personalDetailsData: PropTypes.object,
  contactDetailsData: PropTypes.object,
  checkoutDetails: PropTypes.object,
  authDetailsData: PropTypes.object,
  setPostCheckoutCurrentStep: PropTypes.func,
  addGuestCartProducts: PropTypes.func,
  addBundleProductToGuestCart: PropTypes.func,
  removeCreditCheckStates: PropTypes.func,
  addCouponToCart: PropTypes.func,
  addSimpleProductToGuestCart: PropTypes.func,
  addConfigurableToGuestCart: PropTypes.func,
  clickAndCollectEnabled: PropTypes.bool,
  creditVettingDetails: PropTypes.object,
  paymentOptionsEnabled: PropTypes.bool,
  setCartMulti: PropTypes.func,
  showGuestCart: PropTypes.func,
  setHelpLeadBucket: PropTypes.func,
  setPaymentMethodUrl: PropTypes.func,
  setPostOrderResponse: PropTypes.func,
};

export const getServerSideProps = async () => {
  let paymentDetails = config.paymentConfig;
  paymentDetails.payServerUser = k8sConfig.get("payment.payserveruser");
  paymentDetails.paymentGatewayBaseUrl = k8sConfig.get(
    "payment.paymentgatewaybaseurl"
  );
  paymentDetails.paymentGatewayUrl = k8sConfig.get("payment.paymentgatewayurl");
  paymentDetails.transactionStatusCallbackFormat = k8sConfig.get(
    "payment.transactionstatuscallbackformat"
  );
  paymentDetails.transactionStatusCallbackMethod = k8sConfig.get(
    "payment.transactionstatuscallbackmethod"
  );
  paymentDetails.transactionStatusCallbackUrl = k8sConfig.get(
    "payment.transactionstatuscallbackurl"
  );
  paymentDetails.currency = k8sConfig.get("payment.currency");
  paymentDetails.transactionType = k8sConfig.get("payment.transactiontype");
  paymentDetails.merchantIdentifier = k8sConfig.get(
    "payment.merchantidentifier"
  );
  paymentDetails.encType = k8sConfig.get("payment.enctype");
  let categoryId = k8sConfig.get("category.dealcategoryid");

  const vodacomPrepaidTransfer = k8sConfig.get(
    "features.vodacomPrepaidTransfer"
  );
  const otherPrepaidTransfer = k8sConfig.get("features.otherPrepaidTransfer");
  const numberTransferEnabled = k8sConfig.get("features.numberTransfer");
  const paymentOptionsEnabled = k8sConfig.get("features.paymentOptions");
  const clickAndCollectEnabled = k8sConfig.get("features.clickAndCollect");

  return {
    props: {
      paymentConfiguration: paymentDetails,
      dealCategoryId: categoryId,
      vodacomPrepaidTransfer: vodacomPrepaidTransfer === "true",
      otherPrepaidTransfer: otherPrepaidTransfer === "true",
      numberTransferEnabled: numberTransferEnabled === "true",
      paymentOptionsEnabled: paymentOptionsEnabled === "true",
      clickAndCollectEnabled: clickAndCollectEnabled === "true",
    },
  };
};

const mapStateToProps = (state) => ({
  cartDetails: state.cartDetails,
  cartProductItems: state.cartDetails.cartProductItems,
  personalDetailsData: state.creditCheckDetails.personalDetails,
  contactDetailsData: state.creditCheckDetails.contactDetails,
  checkoutDetails: state.checkoutDetails,
  profileData: state.navDetails.profileData,
  authDetailsData: state.checkoutDetails.authDetailsData,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  creditVettingDetails: state.checkoutDetails.creditVettingResult,
});

const mapDispatchToProps = {
  setPostCheckoutCurrentStep,
  addGuestCartProducts,
  addBundleProductToGuestCart,
  removeCreditCheckStates,
  addCouponToCart,
  addSimpleProductToGuestCart,
  addConfigurableToGuestCart,
  setCartMulti,
  showGuestCart,
  setHelpLeadBucket,
  setPaymentMethodUrl,
  setPostOrderResponse,
};

export default connect(mapStateToProps, mapDispatchToProps)(PostCheckout);
